import {
  BarChart3,
  Brain,
  Building2,
  CircleDollarSign,
  Eye,
  FileText,
  Headphones,
  LayoutTemplate,
  Lock,
  MapPin,
  Megaphone,
  MousePointerClick,
  Paintbrush,
  PuzzleIcon,
  Rocket,
  Search,
  Sliders,
  Sprout,
  Target,
  TrendingUp,
  Users,
  Wallet,
  Wrench,
  Zap,
} from "lucide-react";

import type { LucideIcon } from "lucide-react";

const ICON_KEYWORDS: Array<{ keywords: string[]; icon: LucideIcon }> = [
  { keywords: ["lead generation"], icon: Target },
  { keywords: ["seo"], icon: Search },
  { keywords: ["marketing"], icon: Megaphone },
  { keywords: ["template"], icon: LayoutTemplate },
  { keywords: ["customization", "customiz"], icon: Paintbrush },
  { keywords: ["diy"], icon: Wrench },
  { keywords: ["self-service"], icon: MousePointerClick },
  { keywords: ["control"], icon: Sliders },
  { keywords: ["pricing", "price point"], icon: CircleDollarSign },
  { keywords: ["cost", "affordab"], icon: Wallet },
  { keywords: ["investment"], icon: CircleDollarSign },
  { keywords: ["overhead"], icon: CircleDollarSign },
  { keywords: ["specialized", "specialization", "industry needs"], icon: Building2 },
  { keywords: ["flexibility", "industry flex"], icon: PuzzleIcon },
  { keywords: ["home services focus"], icon: Building2 },
  { keywords: ["contract", "commitment"], icon: FileText },
  { keywords: ["long-term"], icon: Lock },
  { keywords: ["reporting"], icon: BarChart3 },
  { keywords: ["transparency"], icon: Eye },
  { keywords: ["support"], icon: Headphones },
  { keywords: ["criteria", "selective"], icon: Users },
  { keywords: ["early-stage"], icon: Sprout },
  { keywords: ["ai capab"], icon: Brain },
  { keywords: ["setup", "implementation"], icon: Rocket },
  { keywords: ["speed"], icon: Zap },
  { keywords: ["ease"], icon: Zap },
  { keywords: ["location", "results by"], icon: MapPin },
  { keywords: ["roi", "value"], icon: TrendingUp },
];

export function getIconForTitle(title: string, fallback: LucideIcon = Target): LucideIcon {
  const lower = title.toLowerCase();
  for (const entry of ICON_KEYWORDS) {
    if (entry.keywords.some((kw) => lower.includes(kw))) {
      return entry.icon;
    }
  }
  return fallback;
}
